import 'react-loading-skeleton/dist/skeleton.css'
import { View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'
import RowListItem from '../RowListItem'
import ArrowRightIcon from '../heroicons/micro/ArrowRightIcon'
import styles from './styles'

import Skeleton from 'react-loading-skeleton'

const CategoryBadges = ({ style = {}, title, facts = [], isLoading }) => {
  return (
    <View style={[styles.badgesContainer, style]}>
      <View
        style={{
          paddingHorizontal: 24,
          paddingVertical: 26,
          backgroundColor: isLoading ? colors.softGrey : colors.primaryBlue,
          borderBottomWidth: 1,
          borderColor: colors.lightGrey
        }}
      >
        <MarkdownText style={typoStyles.H4White}>
          {isLoading ? <Skeleton width={200} /> : title}
        </MarkdownText>
      </View>
      <View
        style={{
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          rowGap: 16
        }}
      >
        {facts.map((fact, index) =>
          isLoading ? (
            <Skeleton key={index} height={24} />
          ) : (
            <RowListItem key={index} Icon={ArrowRightIcon} text={fact} />
          )
        )}
      </View>
    </View>
  )
}

export default CategoryBadges
